import { authClient, API } from '../index'

// Get all usersCustomer
export const getUsersCustomer = () => {
    return authClient().get(`${API}/userCustomer/?getDisabled=true`)
}

// Get userCustomer by id
export const getUserCustomerById = (id) => {
    return authClient().get(`${API}/userCustomer/${id}`)
}

// Create userCustomer
export const postUserCustomer = async (userCustomer) => {
    return authClient().post(`${API}/userCustomer`, userCustomer)
}

// Update userCustomer
export const updateUserCustomer = async (id, userCustomer) => {
    return authClient().put(`${API}/userCustomer/${id}`, userCustomer)
}

// Delete user
export const deleteUserCustomer = (id) => {
    return authClient().delete(`${API}/userCustomer/${id}`)
}

// Change status userCustomer
export const changeStatusUserCustomer = async (id, active) => {
    return authClient().put(`${API}/userCustomer/change-status/${id}`, { active });
};


// Create userCustomer
export const signUpUserCustomer = async (userCustomer) => {
    return authClient().post(`${API}/userCustomer/signup`, userCustomer)
}


export const getActiveUsers = () => {
    return authClient().get(`${API}/userCustomer/refresh-connection`)
}